import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { BotFeatures, Dictionary } from '@feedyou/schema'
import { DevToolsControlPosition } from './types'

export type ForcedBotFeatures = Dictionary<BotFeatures, boolean>

type State = {
  isOpen: boolean
  position: DevToolsControlPosition
  forcedBotFeatures: ForcedBotFeatures
  displayUnreleasedHostingVersions: boolean
}

export const initialState: State = {
  isOpen: false,
  position: 'bottom-right',
  forcedBotFeatures: {},
  displayUnreleasedHostingVersions: false
}

const slice = createSlice({
  name: 'devTools',
  initialState,
  reducers: {
    setControlsOpenStatus: (state, actions: PayloadAction<boolean>) => {
      state.isOpen = actions.payload
    },
    toggleControls: state => {
      state.isOpen = !state.isOpen
    },
    setControlsPosition: (state, actions: PayloadAction<DevToolsControlPosition>) => {
      state.position = actions.payload
    },
    setForcedBotFeatures: (state, actions: PayloadAction<ForcedBotFeatures>) => {
      state.forcedBotFeatures = actions.payload
    },
    modifyForcedBotFeatures: (state, actions: PayloadAction<ForcedBotFeatures>) => {
      state.forcedBotFeatures = { ...state.forcedBotFeatures, ...actions.payload }
    },
    setDisplayUnreleasedHostingVersions: (state, actions: PayloadAction<boolean>) => {
      state.displayUnreleasedHostingVersions = actions.payload
    }
  }
})

export const devToolsReducer = slice.reducer
export const devToolsSliceActions = slice.actions
